import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=7592e0e2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserManagement.vue"
export default component.exports